import { useRef, useState } from "react";
import Select, { createFilter } from "react-select";
import styles from "./react-select-wrapper.less";

type ReactSelectWrapperProps = {
    id: string;
    isRequired: boolean;
    value: string;
    onChange: (value: any) => void;
};

export const ReactSelectWrapper = (props: ReactSelectWrapperProps) => {
    const { isRequired, id = null } = props;
    const [state, setState] = useState({
        value: props.value
    });
    const selectRef = useRef(null);

    const onFocus = () => {
        if (selectRef.current) {
            selectRef.current.focus();
        }
    }

    const onChange = (value: any) => {
        props.onChange(value);
        setState({ value });
    };


    const getValue = () => {
        if (props.value !== undefined && props.value !== null) {
            return props.value;
        }
        return state.value || "";
    }

    return (
        <div className={styles.reactSelectWrapper}>
            <Select
                inputId={id}
                {...props}
                filterOption={createFilter({ ignoreAccents: false })}
                onChange={onChange}
                ref={selectRef}
            />
            {isRequired && (
                <input
                    tabIndex={-1}
                    autoComplete="off"
                    className={styles.hiddenInput}
                    value={getValue()}
                    onChange={() => { }}
                    onFocus={onFocus}
                    required
                />
            )}
        </div>
    );
};